export const setDeskIdSunco = ({
  i,
  intent,
  use_custom_fields,
  integrations,
  getCustomFields,
  updateIntent,
}) => {
  const sunco_integration = integrations?.find(
    (int) => int.channel === "sunco"
  );

  const sunco_active =
    sunco_integration?.info?.zendesk?.use_custom_fields?.active;

  if (sunco_active) {
    const sunco_channel_id = sunco_integration?.channel_id;

    if (intent.parameters && intent.parameters[i]) {
      if (!intent.parameters[i].zendesk_ticket_field) {
        intent.parameters[i].zendesk_ticket_field = {};
      }

      if (!intent.parameters[i].zendesk_ticket_field.desk_id) {
        intent.parameters[i].zendesk_ticket_field.desk_id = sunco_channel_id;
      }

      updateIntent(intent);
    }
    if (!use_custom_fields || !use_custom_fields[sunco_channel_id]) {
      getCustomFields("sunco", sunco_channel_id, intent);
    }
  }
};
